export enum TopupTypes {
  FREE = 'FREE',
  PAID = 'PAID',
}
